import React, { useMemo } from 'react';
import { ghostStudioAuthEmbedUrl } from '../../config/auth';
import './GhostAuthProbe.css';

interface GhostAuthProbeProps {
  active: boolean;
  refreshKey?: number;
}

/**
 * Invisible iframe that probes Ghost member session from www.aixenergy.io
 * and posts the verified session token to the parent window cross-origin.
 */
export const GhostAuthProbe: React.FC<GhostAuthProbeProps> = ({ active, refreshKey = 0 }) => {
  const src = useMemo(
    () => ghostStudioAuthEmbedUrl(typeof window !== 'undefined' ? window.location.href : undefined),
    [refreshKey]
  );

  if (!active) {
    return null;
  }

  return (
    <iframe
      key={refreshKey}
      className="ghost-auth-probe"
      title="Ghost member authentication probe"
      src={src}
      tabIndex={-1}
      aria-hidden="true"
      referrerPolicy="strict-origin-when-cross-origin"
    />
  );
};
